module.exports = __webpack_public_path__ + "img/public/SiteIcons/hostStepIcons/discount.svg?b3629ec6";